// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2f963c84","312":"86c98f36","453":"1b276051","800":"a4ff0ebb"}[chunkId] + ".chunk.js";
};